import { render } from "./IconRemove.vue?vue&type=template&id=3f08322a"
import script from "./IconRemove.vue?vue&type=script&lang=js"
export * from "./IconRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__